import React, {} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import GroheFiltersValues from "../../grohe/groheNavigation/groheFilters/groheFiltersValues";
import {setSelectedFilters} from "../../../../actions/actionFunctions";
import {getFeatureGroupFilters} from "../../../../misc/filtersFunctions";
import MaterialSpinner from "../../../ui/materialSpinner";


const ShopCategoryAside = (props) => {

  const {featureGroup, isMobile, shopNavItems} = props;

  const availableFilters = !featureGroup.allFeaturesReceived ? [] : getFeatureGroupFilters(featureGroup, shopNavItems);
  // console.log("availableFilters", availableFilters);

  if (isMobile) {
    return null
  }

  return (
    <div className="shop-aside">
      <div className="grohe-filters__list text-left">
        {availableFilters.map(availableFilter => {
          return (
            <li className="lk-info__list-item" key={availableFilter.id}>
              <div className="grohe-filters__list-item-header">
                <span className="lk-info__header-title">
                  {availableFilter.filterGroupName}
                  {availableFilter.selectedFiltersLength ? ` (${availableFilter.selectedFiltersLength})` : null}
                </span>
                {featureGroup.filtersReceived || featureGroup.realFeaturesReceived ? null : <MaterialSpinner size={20}/>}
              </div>
              <div className="lk-info__content">
                <GroheFiltersValues availableFilter={availableFilter} featureGroup={featureGroup}/>
              </div>
            </li>
          )
        })}
      </div>
    </div>
  )
};

ShopCategoryAside.propTypes = {
  shopNavItems: PropTypes.array
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {selectedFilters, filtersCount} = store.filterState;
  return {
    isMobile,
    selectedFilters,
    filtersCount
  };
};

const mapDispatchToProps = {
  setSelectedFilters,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopCategoryAside)
)
